module.exports = __webpack_public_path__ + "static/media/loo.627692a3.ogg";